<template>
    <component
        v-bind="$attrs"
        :is="tag"
        :type="type"
        :disabled="loading ? true : undefined"
        class="flex items-center rounded-sm text-sm font-bold whitespace-nowrap text-white"
        :class="{
            [bgClass]: true,
            'hover:bg-orange-500 focus:bg-orange-500': !disabled,
            'cursor-not-allowed': disabled,
            [disabledClass]: disabled,
            'px-1 py-0': size === 'xs',
            'px-2 py-1': size === 'small',
            'px-6 py-3': size === 'default',
        }"
        @click="(e: MouseEvent) => emit('click', e)"
    >
        <div v-if="loading" class="btn-spinner mr-2" />
        <div>
            <slot />
        </div>
    </component>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        tag?: string;
        type?: string;
        bgClass?: string;
        disabledClass?: string;
        size?: 'xs' | 'small' | 'default';
        loading?: boolean;
        disabled?: boolean;
    }>(),
    {
        bgClass: 'bg-indigo-600',
        disabled: false,
        disabledClass: 'bg-indigo-300',
        loading: false,
        size: 'default',
        tag: 'button',
        type: 'button',
    },
);

const emit = defineEmits<{
    click: [e: MouseEvent];
}>();
</script>

<style>
.btn-spinner,
.btn-spinner:after {
    border-radius: 50%;
    width: 1.5em;
    height: 1.5em;
}

.btn-spinner {
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 0.2em solid white;
    border-right: 0.2em solid white;
    border-bottom: 0.2em solid white;
    border-left: 0.2em solid transparent;
    transform: translateZ(0);
    animation: spinning 1s infinite linear;
}

@keyframes spinning {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
